import React, { useContext, useEffect } from 'react';
import { Brain, Zap, Code, Database, BarChart, Shield } from 'lucide-react';
import './aichatbotbase.css';
import { useNavigate } from 'react-router';
import AuthContext from '../SecurityConfig/AuthContext';
import Header from './Header';
const features = [
  {
    icon: <Brain className="icon" />,
    title: 'Document Understanding',
    description: 'Processes and comprehends uploaded documents, extracting key information and insights for accurate responses.'
  },
  {
    icon: <Zap className="icon" />,
    title: 'Prompt-Based Assistance',
    description: 'Provides intelligent answers to user prompts by analyzing document content and context.'
  },
  {
    icon: <Code className="icon" />,
    title: 'External Knowledge Integration',
    description: 'Fetches information from external websites when document data is insufficient, ensuring comprehensive answers.'
  },
  {
    icon: <Database className="icon" />,
    title: 'Knowledge Base Expansion',
    description: 'Continuously learns and updates its knowledge base from user interactions and uploaded documents.'
  },
  {
    icon: <BarChart className="icon" />,
    title: 'Insightful Analytics',
    description: 'Generates detailed insights and summaries from document data for better decision-making.'
  },
  {
    icon: <Shield className="icon" />,
    title: 'Secure Data Handling',
    description: 'Ensures the privacy and security of uploaded documents with robust encryption and compliance standards.'
  }
];

const BeginnerGuide = () => {
  const navigate = useNavigate();
  const { setLoginDetails, loginDetails } = useContext(AuthContext);
  useEffect(() => {
    if (loginDetails.isAuthenticated) navigate('/chatbotbase/allfiles');
  }, []);
  return (
    <>
      <Header />
      <div className="chatbotbase">
        <div className="container">
          <div className="wrapper">
            {/* Hero Section */}
            <div className="hero">
              <h1 className="hero-title">
                AI <span className="highlight">Virtual</span> Assistant
              </h1>
              <p className="hero-description">
                An intelligent automation tool that processes, analyzes, and transforms your data while providing actionable insights
                through advanced machine learning algorithms.
              </p>
            </div>

            {/* Features */}
            <div className="features-box">
              <h2 className="features-heading">What This AI Utility Does</h2>
              <div className="features-grid">
                {features.map((feature, idx) => (
                  <FeaturePoint key={idx} {...feature} />
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="cta">
              {/* Optional button */}
              <button className="cta-button" onClick={() => navigate('/chatbotbase/signin')}>
                Try AI Utility Now
              </button>
              <p className="cta-note">No coding knowledge required • Easy setup in minutes</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default BeginnerGuide;
